import { IonButton } from '@ionic/react';
import { useState } from 'react';
import { addDays } from '../../domain/dates';
import { formatDate } from '../i18n/format';
import { useMessages } from '../i18n/LanguageProvider';
import { useAppData } from '../state/AppDataProvider';
import { currentPlan } from '../state/plan-service';
import { usePlanEdits } from '../state/use-plan-edits';

/**
 * DE: Plan anlegen: der erste, oder in den letzten Tagen eines Plans der nächste.
 * EN: Create a plan: the first one, or the next one during a plan's last days.
 */
export function PlanPrompt({ mode }: { mode: 'first' | 'next' }) {
  const { data, today } = useAppData();
  const plans = usePlanEdits();
  const { language, t } = useMessages();
  const [busy, setBusy] = useState(false);
  const current = mode === 'next' ? currentPlan(data, today) : undefined;
  const lastDay = current && addDays(current.period.start, current.period.days - 1);
  const startsMonth = lastDay !== undefined && addDays(lastDay, 1).endsWith('-01');
  const create = (kind: 'month' | 'week') => {
    setBusy(true);
    // DE: Nach Erfolg bleibt der Hinweis „Plan wird erstellt“, bis der neue Plan die Aufforderung
    // ersetzt; ein zweiter Tipp würde sonst schon den Folgeplan anlegen.
    // EN: After success the "planning" note stays until the new plan replaces the prompt; a second
    // tap would otherwise already create the following plan.
    void plans.create(kind).catch((error: unknown) => {
      setBusy(false);
      throw error;
    });
  };
  return (
    <section className="app-card">
      <p className="app-lead">
        {lastDay ? t.planEnds(formatDate(lastDay, language, 'weekday-long')) : t.noPlanTitle}
      </p>
      {busy ? (
        <p className="app-muted">{t.planning}</p>
      ) : (
        <div className="app-actions">
          <IonButton onClick={() => create('month')}>
            {startsMonth ? t.nextMonth : t.planMonth}
          </IonButton>
          <IonButton fill="outline" onClick={() => create('week')}>
            {mode === 'next' ? t.nextWeek : t.planWeek}
          </IonButton>
        </div>
      )}
    </section>
  );
}
